import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import { JWTProvider as AuthProvider } from "./context/JWTContext";
import { AppConfigProvider } from "./context/AppConfigContext";
import BootstrapGate from "./components/BootstrapGate";
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <AuthProvider>
        <AppConfigProvider>
          <BootstrapGate>
            <AppRouter />
          </BootstrapGate>
        </AppConfigProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
